const LAYOUT_COMPONENT_FOOTER_CONFIGURATION_BUTTON_PROPS = {
  dataTestId: 'layout-footer-configuration-button',
  size: 'LARGE',
  type: 'PRIMARY',
};

export { LAYOUT_COMPONENT_FOOTER_CONFIGURATION_BUTTON_PROPS };
